'use strict';

module.exports = function unwrap(value) {
  if (value instanceof this.constructor) {
    return value.all();
  }

  return value;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/unwrap.js
// module id = 1286
// module chunks = 2